

import { DownOutlined } from '@ant-design/icons';
import { Dropdown, Menu, Space, message } from 'antd';
import modal from 'antd/lib/modal';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { getCookie } from 'typescript-cookie';
import { ChangePassword } from '../../models/changePswd';
import { Paths } from '../../paths';
import { useChangeMyPasswordMutation } from '../../redux/api/userApis/usersApi';
import { AppDispatch } from '../../redux/root/root.store';
import { AuthSliceMethods, getAuthState } from '../../redux/slices/authSlice';
import { ChangePasswordModal } from './ChangePasswordModal';


export const UserDropDown = () => {
  const { t } = useTranslation();
  const dispatch: AppDispatch = useDispatch();
  const [changePassModalVisible, setChangePassModalVisible] = useState<boolean>(false);
  const [changePasswordUser] = useChangeMyPasswordMutation();
  const { name, secondName, patronymic, roles } = useSelector(getAuthState);
  const handleLogout = async () => {
    dispatch(AuthSliceMethods.logout());
    <Navigate to={Paths.login} />;
  };
  const handleChangePassword = async () => {
    setChangePassModalVisible(true);
  };
  async function onChangePassword(changedPassword: ChangePassword): Promise<boolean> {

    try {
      let status: boolean = false;
      await changePasswordUser(changedPassword).then((response: any) => {
        if (response.error) {
          const isKyrgyz = getCookie('i18next') === 'ky';
          const lang = isKyrgyz ? 'kg' : 'ru';
          const res = response.error.data?.res;
          const errorMessages = Array.isArray(res)
              ? res.map((error: any) => error[lang] || error.ru).join('\n')
              : response.error.data?.msg || t('unknownError'); 
          throw new Error(errorMessages);
      }
        if (response.data.success) {
          status = true;
          modal.success({ title: t('msg.success'), content: t('msg.successAdd') });
        }
      }).catch((error) => {
        modal.error({ title: t('msg.error'), content: String(error.message) });
      });
      return status;
    } catch (error: any) {
      message.error(String(error));
      return false;
    }
  }
  const menu = (
    <Menu
      items={[
        {
          label: (
            <div
              onClick={() => {
                handleChangePassword()
              }}
            >
              {t('auth.change_password')}
            </div>
          ),
          key: "0",
        },
        {
          label: (
            <div
              onClick={() => {
                handleLogout()
              }}
            >
              {t('header.logout')}
            </div>
          ),
          key: "1",
        },
      ]} />
  );
  return (
    <>

      <Dropdown overlay={menu} className="userDropDown">
        <a onClick={(e) => e.preventDefault()}>
          <Space>
            <div>
              <p className="username">
                {name} {patronymic} {secondName}
                <br />
                
              </p>

            </div>
            <DownOutlined style={{ position: "relative", top: 4 }} />
          </Space>
        </a>
      </Dropdown>
      <ChangePasswordModal
        show={changePassModalVisible}
        onHide={() => setChangePassModalVisible(false)}
        onSubmit={onChangePassword}
      />
    </>
  );
};